var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99988 4.5C3.99988 3.11929 5.11917 2 6.49988 2H13.4999C14.8806 2 15.9999 3.11929 15.9999 4.5V17.5C15.9999 17.6881 15.8944 17.8602 15.7268 17.9456C15.5592 18.0309 15.3579 18.015 15.2058 17.9044L9.99988 14.1183L4.79396 17.9044C4.64187 18.015 4.44057 18.0309 4.27299 17.9456C4.1054 17.8602 3.99988 17.6881 3.99988 17.5V4.5Z",
    fill: "#F36E22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFilled);
export default __webpack_public_path__ + "static/media/bookmark-filled.8b163b6b7ca625008cf99388f0979266.svg";
export { ForwardRef as ReactComponent };